import { createAction } from '@reduxjs/toolkit';
import { GANTRY_LED_STATE } from '@volterainc/common';

//These are duplicated from nova-sw/common/client/actions
export const wifiAcknowledge = createAction('client.WIFI_ACKNOWLEDGE');
export const wifiConnect = createAction<{ ssid: string; password: string }>('client.WIFI_CONNECT');
export const wifiScan = createAction('client.WIFI_SCAN');
export const setGantryLeds = createAction<GANTRY_LED_STATE>('client.REQUEST_GANTRY_LED_STATE');